import React from 'react';
import { dpsTheme, getCategoryIcon, getScoreLevelConfig } from '../../../styles/dpsTheme';

interface CategoryCardProps {
  name: string;
  score: number;
  categoryType: 'protection' | 'surveillance' | 'dissuasion';
}

export const CategoryCard: React.FC<CategoryCardProps> = ({ name, score, categoryType }) => {
  const categoryConfig = dpsTheme.colors.categories[categoryType];
  const levelConfig = getScoreLevelConfig(score);
  const iconPath = getCategoryIcon(categoryType);

  return (
    <div
      className="backdrop-blur-xl border rounded-lg p-4 sm:p-6 transition-all duration-300 cursor-pointer hover:-translate-y-1"
      style={{
        background: dpsTheme.colors.background.card,
        borderColor: dpsTheme.colors.border.primary,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = dpsTheme.colors.border.hover;
        e.currentTarget.style.background = dpsTheme.colors.background.cardHover;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = dpsTheme.colors.border.primary;
        e.currentTarget.style.background = dpsTheme.colors.background.card;
      }}
    >
      <div className="flex items-center gap-3 mb-3 sm:mb-4">
        <div
          className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center"
          style={{
            background: categoryConfig.bg,
            border: `1px solid ${categoryConfig.border}`,
            color: categoryConfig.secondary,
          }}
        >
          <svg className="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d={iconPath} />
          </svg>
        </div>
        <div className="text-sm sm:text-base font-semibold text-gray-300">
          {name}
        </div>
      </div>

      <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-2 sm:mb-3">
        {score}
        <span className="text-base sm:text-lg text-gray-600">/100</span>
      </div>

      <div className="w-full h-1.5 bg-white/5 rounded-full overflow-hidden mb-2 sm:mb-3">
        <div
          className="h-full rounded-full transition-all duration-800"
          style={{
            background: categoryConfig.gradient,
            width: `${score}%`,
          }}
        />
      </div>

      <div className="text-xs sm:text-sm text-gray-400">
        {levelConfig.label}
      </div>
    </div>
  );
};
